<template>
  <div class="spv-light-nodes">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
      <div class="fill"></div>
      <instruction-btn
        :id="instruction.spvlightnodes.id"
        :instruction-info="instruction.spvlightnodes.instructionInfo"
      ></instruction-btn>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :show-edit="true"
        :paging="paging"
        :operate-col="operatorCol"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="chains" slot-scope="{ param }">
          <div>
            <div v-for="item in param.row.Chains" :key="item.id">{{ item.chainId }}</div>
          </div>
        </template>
        <template slot="status" slot-scope="{ param }">
          <div class="node-status" :class="param.row.status | transStatusClass">
            <span class="iconfont" :class="param.row.status | transStatusIcon"></span>
            {{ param.row.status | transStatus($constants.EMPTY) }}
          </div>
        </template>
      </normal-table>
    </common-bg-plate>
    <create-spv-node
      :dialog-visible.sync="showCreateDialog"
      @createSuccess="getList"
    ></create-spv-node>
    <delete-spv-node
      :handle-info="handleInfo"
      :dialog-visible.sync="showDeleteDialog"
      @deleteSuccess="getList"
    ></delete-spv-node>
    <download-dialog
      :dialog-visible.sync="showDownloadDialog"
      title="下载SPV轻节点包"
      :file-url="downloadUrl"
      :file-name="downloadFileName"
    ></download-dialog>
    <subscribe-spv-node
      :handle-info="handleInfo"
      :dialog-visible.sync="showSubscribeSpvNodeDialog"
      @subscribeSuccess="getList"
    ></subscribe-spv-node>
    <check-block-info
      :handle-info="handleInfo"
      :dialog-visible.sync="showCheckBlockInfoDialog"
      @checkSuccess="showBlockInfo"
      @checkFailed="getList"
    ></check-block-info>
    <block-info :block-info="blockInfo" :dialog-visible.sync="showBlockInfoDialog"></block-info>
  </div>
</template>

<script>
import instruction from '@/instruction/index'
import { mapState, mapActions } from 'vuex'
import createSpvNode from './components/createSpvNode'
import deleteSpvNode from './components/deleteSpvNode'
import subscribeSpvNode from './components/subscribeSpvNode'
import checkBlockInfo from './components/checkBlockInfo'
import blockInfo from './components/blockInfo'

export default {
  name: 'Index',
  components: {
    createSpvNode,
    deleteSpvNode,
    subscribeSpvNode,
    checkBlockInfo,
    blockInfo
  },
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == 0) {
        return '未订阅'
      } else if (value == 1) {
        return '已订阅'
      } else if (value == 2) {
        return '服务未启动'
      } else {
        return defaultVal
      }
    },
    transStatusClass: function(value) {
      if (value == 0) {
        return 'is-no-subscribe'
      } else if (value == 1) {
        return 'is-subscribe'
      } else if (value == 2) {
        return 'is-no-working'
      } else {
        return ''
      }
    },
    transStatusIcon: function(value) {
      if (value == 0) {
        return 'icon-round-wrong'
      } else if (value == 1) {
        return 'icon-round-right'
      } else if (value == 2) {
        return 'icon-round-waiting'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      showDownloadDialog: false,
      downloadUrl: '',
      downloadFileName: '',
      showCreateDialog: false,
      showSubscribeSpvNodeDialog: false,
      showDeleteDialog: false,
      showCheckBlockInfoDialog: false,
      showBlockInfoDialog: false,
      handleInfo: null,
      blockInfo: null,
      btnList: [
        {
          btnContent: '创建SPV节点',
          click: () => {
            return this.createSpvNode()
          },
          icon: 'icon-add'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'id',
          label: 'ID',
          minWidth: 116
        },
        {
          prop: 'Chains',
          label: '关联区块链',
          slotName: 'chains',
          minWidth: 206
        },
        {
          prop: 'serverIP',
          label: 'IP地址',
          minWidth: 155
        },
        {
          prop: 'webPort',
          label: 'Web端口',
          minWidth: 112
        },
        {
          prop: 'grpcPort',
          label: 'GRPC端口',
          minWidth: 112
        },
        {
          prop: 'status',
          label: '订阅状态',
          slotName: 'status',
          minWidth: 138
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 174
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '订阅',
          click: (row, col, cellValue) => {
            return this.handleSubscribe(row)
          },
          showText: true,
          formatter: (row, col, cellValue) => {
            return row.status != 1
          },
          icon: 'icon-subscribe'
        },
        {
          text: '查询',
          click: (row, col, cellValue) => {
            return this.handleCheck(row)
          },
          showText: true,
          formatter: (row, col, cellValue) => {
            return row.status == 1
          },
          icon: 'icon-check'
        },
        {
          text: '删除',
          click: (row, col, cellValue) => {
            return this.deleteSpvNode(row)
          },
          icon: 'icon-cancel',
          class: 'operate-danger',
          showText: true
        },
        {
          text: '下载',
          click: (row, col, cellValue) => {
            return this.startDownload(row)
          },
          icon: 'icon-download',
          showText: true
        }
      ],
      operatorCol: {
        minWidth: 186
      },
      instruction
    }
  },
  computed: {
    ...mapState({
      list: state => state.spvlightnodes.spv_light_nodes_list,
      paging: state => state.spvlightnodes.spv_light_nodes_paging
    })
  },

  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getSpvLightNodesLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit
      }
      this.getSpvLightNodesLists(params)
    },
    subscribeStatus(status) {
      let statusArr = ['未订阅', '已订阅', '服务未启动']
      return statusArr[status]
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleSubscribe(row) {
      this.handleInfo = row
      this.showSubscribeSpvNodeDialog = true
    },
    createSpvNode(row) {
      this.showCreateDialog = true
    },
    deleteSpvNode(row) {
      this.handleInfo = row
      this.showDeleteDialog = true
    },
    startDownload(row) {
      this.handleInfo = row
      this.downloadUrl = `/cbaas-service/v1/spv/download?spvId=${this.handleInfo.id}`
      this.downloadFileName = `Light_Node_${this.handleInfo.id}_部署包.zip`
      this.showDownloadDialog = true
    },
    handleCheck(row) {
      this.handleInfo = row
      this.showCheckBlockInfoDialog = true
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    showBlockInfo(data) {
      this.blockInfo = data
      this.showBlockInfoDialog = true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('spv-light-nodes', (), ());
.spv-light-nodes {
  @include adaptation(());

  .normal-table-wrap {
    /deep/ {
      .normal-table {
        .node-status {
          &.is-no-subscribe {
            color: var(--base-color-danger);
          }

          &.is-subscribe {
            color: var(--base-color-success);
          }

          &.is-no-working {
            color: #ffb013;
          }
        }
      }
    }
  }
}
</style>
